export default __webpack_public_path__ + "static/media/icon-like.596e9a40.svg";